import request from '@/utils/request'
import qs from 'qs'

const api = {
	list: '/card/cardList', //获取持卡人列表
	list1: '/card/cardList1', //获取持卡人列表
	add: '/card/bind',//添加
	unbind: '/card/unbind',//解除绑定
	getCardInfo:'/card/getCardInfo',//获取默认卡信息
	ykczList:'/card/ykczList',//医卡充值记录
	getMenzJl:'/card/getMenzJl',//就诊记录
	getMenzdj:'/card/getMenzdj',//门诊单据信息
	getCardBykh:'/card/getCardBykh',//获取医卡建档信息
	getCardPay:'/card/getCardPay',//医卡充值
	getUnMenzdj:'/card/getUnMenzdj',//代缴费信息
	doMenzPay:'/card/doMenzPay',//处方缴费-医卡通
	getByNameIdcard:'/card/getByNameIdcard' ,//返回用户医卡列表-his返回
	doMenzPayWX:'/card/doMenzPayWX',//处方缴费-微信支付
	medPlaceOrder:'/healthCarePay/weix/medPlaceOrder',//医保下单
	wxMedGroupPay:'/healthCarePay/weix/medGroupPay',//医保聚合支付
	getOrderInfo:'/open/queryMedOrderInfo',//查询医保订单结果（前端每3秒调一次查询）
	pageDemo:'/card/pageDemo',//分页演示demo
}

export function pageDemo(parameter) {
	return request({
	  url: api.pageDemo,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
}
export function getUserCardList(parameter) {
	return request({
	  url: api.list,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
}
export function getUserCardList1(parameter) {
	return request({
	  url: api.list1,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
}

export function add(parameter) {
	return request({
	  url: api.add,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
	
}
//解除绑定
export function unbind(parameter) {
	return request({
	  url: api.unbind,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
}

export function getCardInfo(parameter) {
	return request({
	  url: api.getCardInfo,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
}
export function ykczList(parameter) {
	return request({
	  url: api.ykczList,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
}

export function getMenzJl(parameter) {
	return request({
	  url: api.getMenzJl,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
}


export function getMenzdj(parameter) {
	return request({
	  url: api.getMenzdj,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
}

export function getCardBykh(parameter) {
	return request({
	  url: api.getCardBykh,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
}

export function getCardPay(parameter) {
	return request({
	  url: api.getCardPay,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
}

export function getUnMenzdj(parameter) {
	return request({
	  url: api.getUnMenzdj,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
}

export function doMenzPay(parameter) {
	return request({
	  url: api.doMenzPay,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
}

export function getByNameIdcard(parameter) {
	return request({
	  url: api.getByNameIdcard,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
}

export function doMenzPayWX(parameter){
	return request({
	  url: api.doMenzPayWX,
	  method: 'post',
	  data: qs.stringify(parameter)
	})
}


//处方缴费医保下单
export function medPlaceOrder(parameter) {
	return request({
		url: api.medPlaceOrder,
		method: 'post',
		data: qs.stringify(parameter),
		// 自定义配置
		customs: {
			isLoading: true,
			loadingText: '医保下单中...',
			successTip:'医保下单成功'
		},
	})
}

/**
 * 医保下单之后支付
 * @param parameter
 * @returns {*}
 */
export function wxMedGroupPay(parameter) {
	return request({
		url: api.wxMedGroupPay,
		method: 'post',
		data: qs.stringify(parameter),
		// 自定义配置
		customs: {
			isLoading: true,
			loadingText: '医保支付中...'
		},
	})
}


/**
 * 查询医保订单
 * @param parameter
 * @returns {*}
 */
export function getOrderInfo(parameter) {
	return request({
		url: api.getOrderInfo,
		method: 'post',
		data: qs.stringify(parameter),
	})
}